import * as XLSX from 'xlsx';
import { TranslateService } from "@ngx-translate/core";

import { Driver } from "@commons/models/domain/Driver";
import { ViewWorkers } from '@layout/driver/services/worker.service';
import { driverLicenseToText } from './workers/driver-license-status';

export function exportWorkersToXLS(data: Driver[], viewType: ViewWorkers, translate: TranslateService) {
  const fileNameTranslate = `${ translate.instant('listOfWorkers')}_${ new Date().toLocaleString() }.xlsx`;

  if (!Array.isArray(data) || data.length === 0) {
      console.error("Dane muszą być tablicą obiektów.");
      return;
  }

  const formattedData = data.map(item => {
    const row: any = {
      [translate.instant('labels.first-name')]: item.FN || '',
      [translate.instant('labels.last-name')]: item.LN || '',
      [translate.instant('vehicle-indicator.group')]: item.UN || '',
      [translate.instant('labels.email')]: item.Em || '',
      [translate.instant('labels.phone-number')]: item.CN || ''
    };

    if (viewType === ViewWorkers.Active) {
      row[translate.instant('driverLicense')] = item.L || '-';
      row[translate.instant('driverLicenseStatusText')] = driverLicenseToText(item, translate);
    }

    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, translate.instant('listOfWorkers'));
  XLSX.writeFile(workbook, fileNameTranslate);
}
